<!-- Notifications toggle -->
<button mat-icon-button (click)="openPanel()" #notificationsOrigin>
    @if (unreadCount > 0) {
    <span class="absolute left-0 right-0 top-0 flex h-3 items-center justify-center">
        <span
            class="ml-4 mt-2.5 flex h-4 min-w-4 shrink-0 items-center justify-center rounded-full bg-teal-600 px-1 text-xs font-medium text-indigo-50">
            {{ unreadCount }}
        </span>
    </span>
    }
    <mat-icon [svgIcon]="'heroicons_outline:bell'"></mat-icon>
</button>

<!-- Notifications panel -->
<ng-template #notificationsPanel>
    <div
        class="fixed inset-0 flex flex-col overflow-hidden shadow-lg sm:static sm:inset-auto sm:w-90 sm:min-w-90 sm:rounded-2xl">
        <!-- Header -->
        <div class="flex shrink-0 items-center bg-primary py-4 pl-6 pr-4 text-on-primary">
            <div class="-ml-1 mr-3 sm:hidden">
                <button mat-icon-button (click)="closePanel()">
                    <mat-icon class="text-current icon-size-5" [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
                </button>
            </div>
            <div class="text-lg font-medium leading-10">Notifications</div>
            <div class="ml-auto">
                <button class="dark:text-white" mat-icon-button [matTooltip]="'Tout marquer comme lu'"
                    [disabled]="unreadCount === 0" (click)="markAllAsRead()">
                    <mat-icon class="text-current icon-size-5" [svgIcon]="'heroicons_solid:envelope-open'"></mat-icon>
                </button>
            </div>
        </div>

        <!-- Content -->
        <div class="bg-card relative flex flex-auto flex-col divide-y overflow-y-auto sm:max-h-120">
            <!-- Notifications -->
            @for (
            notification of notifications;
            track trackByFn($index, notification)
            ) {
            <div class="group flex hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5 transition-colors"
                [ngClass]="{ 'bg-blue-50 dark:bg-blue-900 dark:bg-opacity-20': !notification.read }"
                [class.cursor-pointer]="getEventType(notification) === 'TICKET_OVERDUE'"
                (click)="navigateToNotification(notification)"
                [attr.role]="getEventType(notification) === 'TICKET_OVERDUE' ? 'link' : null"
                [attr.tabindex]="getEventType(notification) === 'TICKET_OVERDUE' ? 0 : null"
                (keydown.enter)="navigateToNotification(notification)">
                <!-- Main content -->
                <div class="flex flex-auto py-4 pl-6">
                    <!-- Icon container with dynamic background -->
                    <div class="mr-4 flex h-10 w-10 shrink-0 items-center justify-center rounded-lg"
                        [ngClass]="getNotificationBodyClasses(notification)">
                        <mat-icon class="icon-size-5" [ngClass]="getNotificationIconClasses(notification)"
                            [svgIcon]="getNotificationIcon(notification)"></mat-icon>
                    </div>

                    <!-- Content section -->
                    <div class="flex flex-auto flex-col">
                        <!-- Title -->
                        <div class="line-clamp-1 font-semibold" [innerHTML]="notification.title"></div>

                        <!-- Dynamic message -->
                        <div class="line-clamp-2 text-sm text-gray-600 dark:text-gray-400 mt-1">
                            {{ getFormattedMessage(notification) }}
                        </div>

                        <!-- Additional details -->
                        @if (getNotificationDetails(notification).length > 0) {
                        <div class="mt-2 flex flex-wrap gap-3">
                            @for (
                            detail of getNotificationDetails(notification);
                            track detail.label
                            ) {
                            <div class="text-xs">
                                <span class="text-gray-500 dark:text-gray-400">
                                    {{ detail.label }}:
                                </span>
                                <span class="font-medium text-gray-700 dark:text-gray-300 ml-1">
                                    {{ detail.value }}
                                </span>
                            </div>
                            }
                        </div>
                        }

                        <!-- Timestamp -->
                        <div class="text-secondary mt-2 text-xs leading-none">
                            @if (notification.createdAt) {
                            {{ notification.createdAt | date: 'dd/MM/yyyy HH:mm' }}
                            } @else {
                            <span class="text-gray-400">Date inconnue</span>
                            }
                        </div>
                    </div>
                </div>

                <!-- Actions -->
                <div class="relative my-4 ml-2 mr-6 flex flex-col gap-1">
                    <!-- Read indicator -->
                    <button class="h-6 min-h-6 w-6" mat-icon-button (click)="$event.stopPropagation(); toggleRead(notification)" (keydown.enter)="$event.stopPropagation()" [matTooltip]="
                                notification.read
                                    ? 'Marquer comme non lu'
                                    : 'Marquer comme lu'
                            ">
                        <span class="h-2 w-2 rounded-full" [ngClass]="{
                                    'bg-gray-400 dark:bg-gray-500 sm:opacity-0 sm:group-hover:opacity-100':
                                        notification.read,
                                    'bg-primary': !notification.read,
                                }"></span>
                    </button>

                    <!-- Delete button -->
                    <button class="h-6 min-h-6 w-6 sm:opacity-0 sm:group-hover:opacity-100" mat-icon-button
                        type="button" (click)="deleteNotification(notification, $event)" (keydown.enter)="$event.stopPropagation()" [matTooltip]="'Supprimer'">
                        <mat-icon class="icon-size-4" [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
                    </button>
                </div>
            </div>
            }

            <!-- No notifications -->
            @if (!notifications || !notifications.length) {
            <div class="flex flex-auto flex-col items-center justify-center px-8 py-12 sm:justify-start">
                <div
                    class="flex h-14 w-14 flex-0 items-center justify-center rounded-full bg-primary-100 dark:bg-primary-600">
                    <mat-icon class="text-primary-700 dark:text-primary-50"
                        [svgIcon]="'heroicons_outline:bell'"></mat-icon>
                </div>
                <div class="mt-5 text-2xl font-semibold tracking-tight">
                    Aucune notification
                </div>
                <div class="text-secondary mt-1 w-full max-w-60 text-center text-md">
                    Vos notifications apparaîtront ici.
                </div>
            </div>
            }
        </div>
    </div>
</ng-template>
